import { FacebookFilled } from '@ant-design/icons';
import styles from './styles.module.scss';

export const SignInWithFacebookButton = (params: {
  text: string;
  loading: boolean;
  onClick: () => Promise<any>;
}) => {
  return (
    <div className={styles.btn} onClick={() => (params.loading ? false : params.onClick())}>
      {params.loading ? (
        <>
          <span className={styles.iconSpan}>
            <FacebookFilled className={styles.icon} />
          </span>
          <span className={styles.buttonText}>{'Signing in...'}</span>
        </>
      ) : (
        <>
          <span className={styles.iconSpan}>
            <FacebookFilled className={styles.icon} />
          </span>
          <span className={styles.buttonText}>{params.text}</span>
        </>
      )}
    </div>
  );
};
